import React from 'react';
import { Form, InputNumber, Row, Col } from 'antd';

interface CorePricingParametersProps {
    form: any;
    setLastChanged: (changed: 'price' | 'margin') => void;
}

export const CorePricingParameters: React.FC<CorePricingParametersProps> = ({
    form,
    setLastChanged,
}) => {
    return (
        <Row gutter={[16, 16]}>
            <Col span={12}>
                <Form.Item name="price" label="目标售价($)" style={{ marginBottom: 12 }}>
                    <InputNumber
                        style={{ width: '100%', fontWeight: 'bold', color: '#1890ff' }}
                        onChange={(v) => {
                            form.setFieldsValue({ price: v });
                            setLastChanged('price');
                        }}
                        prefix="$"
                        precision={2}
                        min={0}
                    />
                </Form.Item>
            </Col>
            <Col span={12}>
                <Form.Item name="profit_margin" label="目标利润率(%)" style={{ marginBottom: 12 }}>
                    <InputNumber
                        style={{ width: '100%', fontWeight: 'bold', color: '#52c41a' }}
                        onChange={(v) => {
                            form.setFieldsValue({ profit_margin: v });
                            setLastChanged('margin');
                        }}
                        suffix="%"
                        precision={1}
                        min={-100}
                        max={100}
                    />
                </Form.Item>
            </Col>
        </Row>
    );
};
